import { useState } from "react";
import { Api } from "../../common/Api";
import { Region } from "../../store/domains/Region";
import { Division } from "../../store/domains/Division";

export const useRegions = () => {
  const [regions, setRegions] = useState<Region[]>([]);
  const [divisions, setDivisions] = useState<Division[]>([]);
  const [loading, setLoading] = useState(false);

  const refresh = () => {
    setLoading(true);
    Api.region
      .regions()
      .then((res) => {
        setRegions(
          res.data.regions.map((x) => {
            return {
              ...x,
              directors: (x.directors || []).length > 0 ? x.directors : [x.director],
              directorIds: (x.directorIds || []).length > 0 ? x.directorIds : [x.directorId],
            };
          })
        );
        setDivisions(
          res.data.divisions.map((x) => {
            return {
              ...x,
              directors: (x.directors || []).length > 0 ? x.directors : [x.director],
              directorIds: (x.directorIds || []).length > 0 ? x.directorIds : [x.directorId],
            };
          })
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return {
    regions,
    divisions,
    loading,
    refresh,
  };
};
